// src/utils/gtag.js
export const GA_ID = 'G-GLF3JW9J4D';

export function loadGtag() {
  if (window.gtag) return; // już załadowane
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_ID}', { page_path: window.location.pathname });
  `;
  document.head.appendChild(script2);
}
